import { Component, OnInit,ViewChild, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam } from 'src/app/shared/models/Global-Search.model';
import { VendorClientAssignmentService } from '../../services';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorClientAssignment } from '../../models';
import { SharedService } from '../../../shared/services/shared.service';
import { Router, ActivatedRoute,NavigationStart } from '@angular/router';
import * as fs from 'file-saver';
import { JwtService } from 'src/app/auth/services';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-vendor-client-assignment',
  templateUrl: './vendor-client-assignment.component.html',
  styleUrls: ['./vendor-client-assignment.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class VendorClientAssignmentComponent implements OnInit {
  isSearchLoading: boolean = false;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton:boolean = false;
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  searchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  vcaSearchSpinner = 'vcaSearchSpinner';
  vcaList: any;
  startSearch: boolean = false;
  dialogPosition = 'topright';
  isVcaAdd : boolean = false;
  vcaForm:FormGroup;
  vendorCompanyList: any;
  clientCompanyList: any;
  loading: boolean = false;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
  loadingSaveButton: boolean = false;
  selectedClientIds;
  public clientIds: Array<any> = [];
  isClientSelected:boolean =false;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorCompanyName', header: 'Vendor Company Name' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorCompanyName', header: 'Vendor Company Name' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;
  createdOnFilterValue: any;
  selectedIsActiveStatus:any;
  @ViewChild('multiSelect') multiSelect: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private vendorClientAssignmentService:VendorClientAssignmentService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router,
    private jwtService:JwtService
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 3000);
    // _router.events.forEach((event) => {
    //   if (event instanceof NavigationStart) {
    //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
         
    //      }
    //      else {
    //       var isTokenAvailable = this.sharedService.isTokenAvailable();
         
    //       if(isTokenAvailable){
    //       setInterval(() =>  this.checkSessionTimeout(), 60000);
    //       }        
    //      }
    //     }
    // });
  //  setInterval(() =>  this.checkSessionTimeout(), 60000);
   /*this.items = [
      {
       label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.assignId)
      }
   ];*/
    }

    checkSessionTimeout()
    {
      var isTokenAvailable = this.sharedService.isTokenAvailable();
      if(isTokenAvailable){
        var result = this.sharedService.checkSessionTimeout();
      
         if(!result) {
           localStorage.removeItem('VMS');
           localStorage.clear();
           this._router.navigateByUrl('/login');
         }
      } 
     
    }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkDeletePermission();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition=[
      {fieldName:"vendorCompanyName",type:"basic"},
      {fieldName:"clientCompanyName",type:"basic"},
      {fieldName:"isActive",type:"dropdown"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];

    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" });
    this.getVendorClientAssignment(); 
    // this.statusValues=['All','Active',"Inactive"];
    this.statusValues = [
      { description: 'All', id: 'All' },
      { description: 'Active', id: 'Active' },
      { description: 'Inactive', id: 'Inactive' }
    ];
    this.InitialSetup();
    this.getVendorCompanyList();
  }

  InitialSetup(){
    this.vcaForm = this._fb.group({
      assignId: new FormControl(0),
      vendorCompanyId: new FormControl(0,[Validators.required]),
      //clientCompanyId: new FormControl(0,[Validators.required]),
      description: new FormControl(""),
      isApproved: new FormControl(true),
      isActive: new FormControl(true,[Validators.required]),
      createdBy: new FormControl(1),
      createdOn: new FormControl(new Date()),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  loadVca(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getVendorClientAssignment();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getAllClaimsMasterList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getVendorClientAssignment()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  getVendorClientAssignment(){
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vcaSearchSpinner);
    this.vendorClientAssignmentService.getVendorClientAssignment(this.searchParam).subscribe(data => {
      //this.appliedFilters = [];
      this.vcaList =data;
      this.isshowpaginator=this.vcaList.length>0?true:false;
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vcaSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  exportVendorClients() {
    this.applyFilter();
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vcaSearchSpinner);
    this.vendorClientAssignmentService.ExportVendorClientAssignment(this.searchParam).subscribe(res => {
    var blob = new Blob([res.body], { type: res.body.type });
    const file = new File([blob],"VendorClients.xlsx", { type: res.body.type });
    fs.saveAs(file);
    });
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedStatus=[];
    this.selectedStatusId=undefined;
    this.createdOnFilterValue = undefined;
    this.selectedIsActiveStatus='';

    // this.applyFilter();
    this.getVendorClientAssignment();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  // applyFilterNew(table: Table){
  //   this.filters=table.filters;
  //   this.applyFilter();
  // }
  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  applyFilter(){
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            // for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            //   if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
            //     this.appliedFilters.push({
            //       field: this.filterCondition[i].fieldName,
            //       matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
            //       value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
            //     })
            // }
            if (this.filterCondition[i].fieldName == "createdOn") {
              this.dateFilterValueSet(this.createdOnFilterValue, "createdOn")
            }
            
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null && this.filters[this.filterCondition[i].fieldName][0].value != 0) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        if(this.filters['isActive'] !==undefined)
        {
          if (this.filters['isActive'][0].value !== null && this.filters['isActive'][0].value != 0) {
            this.getSelectedIsActiveStatus(this.statusValues,this.filters['isActive'][0].value)
          }
          else{
            this.selectedIsActiveStatus= "";
          }
        }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.searchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vcaSearchSpinner);
       this.vendorClientAssignmentService.getVendorClientAssignment(this.searchParam).subscribe(data => {
        // this.appliedFilters = [];
         this.vcaList =data;
         this.isshowpaginator=this.vcaList.length>0?true:false;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.vcaSearchSpinner);
       }, error => {
         console.log(error);
       })
    }
  }

  deleteConfirm(paramId:number){
    this.dialogPosition = 'topright';
    this.confirmationService.confirm({
      message: 'Do you want to delete this Vendor Client Assignment?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.vendorClientAssignmentService.deleteVcaDetail(paramId).subscribe((data: any) => {
          this.getVendorClientAssignment();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

  addVcaDetails(){
    this.isVcaAdd = true;
    this.getClientCompanyNotAdded();
    this.InitialSetup();
    this.clientCompanyList = [];
    // this.getClientCompanyNotAdded();
  }

  getVendorCompanyList(){
    // this.vendorClientAssignmentService.getVendorCompanyList().subscribe(data => {
      this.vendorClientAssignmentService.getRequisitionInvoiceOnlyVendorCompanyList().subscribe(data => {
      this.vendorCompanyList = data;
      if(this.vendorCompanyList.length > 0){
        this.vcaForm.get('vendorCompanyId').setValue(this.vendorCompanyList[0].companyId)
      }
    }, error => {
      console.log(error);
    })
  }

  getClientCompanyNotAdded(){
    let companyId = this.vcaForm.get('vendorCompanyId').value;
    this.vendorClientAssignmentService.getClientsNotAssignmentForVendorCompany(companyId).subscribe(data => {
      this.clientCompanyList = data;
      if(this.clientCompanyList.length > 0){
        this.vcaForm.get('clientCompanyId').setValue(this.clientCompanyList[0].companyId)
      }else{
        this.vcaForm.get('clientCompanyId').setValue(null)
      }
    },
    error => {
      console.log(error);
    })
  }

  getClientListsOnChange(event) {
      if (event.value.length == 0) {
        this.isClientSelected = false;
      }
      else {
        if(event.value.length == 1)
        {
          this.selectedClientIds = event.value[0].companyId;
          this.isClientSelected = true;
        }
        else if(event.value.length > 1)
        {
          this.selectedClientIds = "";
          this.isClientSelected = true;
          for (var k = 0; k < event.value.length; k++) {
            if(k==0)
            {
              this.selectedClientIds =event.value[0].companyId;
            }
            else{
              this.selectedClientIds = this.selectedClientIds + ',' + event.value[k].companyId ;
            }
           
          }
        }
      }
   
  }

  companyNameOnChange(id){
    this.clientCompanyList = [];
    this.selectedClientIds= undefined;
    this.getClientCompanyNotAdded();
  }

  cancel(){
    this.isVcaAdd = false;
    this.InitialSetup();
    this.selectedClientIds= undefined;
    this.isClientSelected = false;
    this.clientIds=[];
    this.multiSelect.filterValue = '';
  }

  save({value}: {value:VendorClientAssignment}){
    this.spinner.show(this.vcaSearchSpinner);
    this.loadingSaveButton = true;
    this.loading = true;
    value.clientCompanyIds =this.selectedClientIds;
    value.createdBy = this.jwtService.getLoggedInUserProfileId();
    this.vendorClientAssignmentService.postVendorClientAssignment(value).subscribe(data=>{
      this.isVcaAdd = false;
      this.selectedClientIds= undefined;
      this.isClientSelected = false;
      this.clientIds=[];
      this.getVendorClientAssignment();
      this.loading = false;
      this.loadingSaveButton = false;
      this.spinner.hide(this.vcaSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkDeletePermission() {
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.assignId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
 displayActionMenu()
 {
   this.items=[];
  if(this.selectedGridMenuItem.isActive == false){
    let tempMenu =  {
      label: 'Activate',
      icon: 'pi pi-fw pi-check',
      command: e => this.activateVendorClientAssignment(this.selectedGridMenuItem)
    }
    this.items.push(tempMenu);
  }
  if(this.selectedGridMenuItem.isActive == true){
    let tempMenu =  {
      label: 'Deactivate',
      icon: 'pi pi-fw pi-times',
      command: e => this.deActivateVendorClientAssignment(this.selectedGridMenuItem)
    }
    this.items.push(tempMenu);
  }
 }
 activateVendorClientAssignment(value:VendorClientAssignment)
 {
  value.modifiedBy = this.jwtService.getLoggedInUserProfileId();
  value.isActive =true;
  this.vendorClientAssignmentService.UpdateVendorClientAssignmentStatus(value).subscribe(data =>{
    this.getVendorClientAssignment();
  });
 }
 deActivateVendorClientAssignment(value:VendorClientAssignment)
 {
  value.isActive =false;
  value.modifiedBy = this.jwtService.getLoggedInUserProfileId();
  this.vendorClientAssignmentService.UpdateVendorClientAssignmentStatus(value).subscribe(data =>{
    this.getVendorClientAssignment();
  });
 }
  createdOnFilterData(e: any) {
  this.createdOnFilterValue = e;
  this.applyFilter();
}
dateFilterValueSet(value, fieldName) {
  if (value !== undefined) {
    for (let j = 0; j < value.length; j++) {
      if (value[j].valueControl !== null) {
        this.appliedFilters.push({
          field: fieldName,
          matchMode: value[j].matchModeControl,
          value: this.datepipe.transform(value[j].valueControl, "MM-dd-yyyy")
        })
      }
    }
  }
}
// getFilterName(status, id) {
//   if (id != null) {
//     let tempStatus = status.filter(data => data.id == id);
//     return tempStatus[0].description
//   } else {
//     return "";
//   }
// }
getSelectedIsActiveStatus(status, id) {
  if (id != null) {
    let tempStatus = status.filter(data => data.id == id);
    this.selectedIsActiveStatus= tempStatus[0].description;
  } else {
    return "";
  }
}
setColumnWidth(value) {
  if (this.showFilters == true && this.showSorting == true) {
    return value + 4 + 'rem'
  } else if (this.showFilters == true || this.showSorting == true) {
    return value + 2 + 'rem'
  }
  else {
    return value + 'rem'
  }
}
}
